import { IPayloadUpdate } from 'app/api/role/model'
import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useUpdateRole } from 'app/react-query/hook/role'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFormUpdateRole, IProps } from './type'

export const useHook = ({ role }: IProps) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IFormUpdateRole>()
  const modalRef = useRef<IRefModal>({})
  const { mutateAsync: mutateAsyncUpdate, isLoading } = useUpdateRole()

  const [isDefault, setIsDefault] = useState(false)

  useEffect(() => {
    form?.setFieldsValue({
      name: role?.name,
      description: role?.description,
      isActive: role?.is_active,
      permissionIds: role?.permissions?.map(item => item?.id) ?? [],
    })
    setIsDefault(!!role?.is_default)
  }, [role])

  const handleSubmit = async (values: IFormUpdateRole) => {
    const newAccount: IPayloadUpdate = {
      id: role?.id,
      name: values?.name,
      description: values?.description,
      is_active: values?.isActive,
      permissionIds: values?.permissionIds,
      isDefault
    }

    await mutateAsyncUpdate?.(newAccount)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
    isDefault,
    setIsDefault
  }
}
